// extracted by mini-css-extract-plugin
export default {"title":"bind-card-form_title__d4S3X","desc":"bind-card-form_desc__h3L3c","row":"bind-card-form_row__kgM8Z","safe":"bind-card-form_safe__hyaqZ","hint":"bind-card-form_hint__1yf5n"};